(() => {
  const choice = '[data-hmh-vip-choice]';
  const handoffKey = 'hmh.mug-store.vip-navigation.v2';
  let selected = false;

  // Carry an explicit choice only while this tab is moving between pages.
  // An open page has no stored selection for a newly opened tab to inherit.
  function restoreChoice(returningFromHistory = false) {
    try {
      const saved = sessionStorage.getItem(handoffKey);
      sessionStorage.removeItem(handoffKey);
      if (!saved) return false;
      const handoff = JSON.parse(saved);
      if (typeof handoff?.from !== 'string' || !handoff.from.startsWith('/') || !Number.isSafeInteger(handoff.at)) return false;
      const elapsed = Date.now() - handoff.at;
      if (!Number.isFinite(elapsed) || elapsed < 0 || elapsed > 120000) return false;
      const navigation = performance.getEntriesByType?.('navigation')[0];
      if (returningFromHistory || navigation?.type === 'back_forward') return true;
      if (navigation?.type === 'reload') return handoff.from === location.pathname;
      if (!document.referrer) return false;
      const previous = new URL(document.referrer);
      return previous.origin === location.origin && previous.pathname === handoff.from;
    } catch { return false; }
  }

  const sync = node => {
    if (node.matches?.(choice)) node.checked = selected;
    for (const input of node.querySelectorAll?.(choice) || []) input.checked = selected;
  };
  selected = restoreChoice();
  sync(document);
  document.addEventListener('change', event => {
    if (!event.target.matches?.(choice)) return;
    if (event.isTrusted) selected = event.target.checked;
    sync(document);
  });
  document.addEventListener('hmh:local-bag-emptied', () => {
    selected = false;
    sync(document);
  });
  // Shopify section rendering replaces the quick view and cart markup.
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) sync(node);
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => {
    try {
      if (selected) sessionStorage.setItem(handoffKey, JSON.stringify({ from: location.pathname, at: Date.now() }));
      else sessionStorage.removeItem(handoffKey);
    } catch { /* The next page defaults to unchecked without storage. */ }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) selected = restoreChoice(true);
    sync(document);
  });

  // The migration guard blocks form submissions. Search is a read-only navigation.
  const search = document.querySelector('[data-hmh-native-search]');
  if (!search) return;
  const field = search.querySelector('input[type="search"]');
  const go = () => {
    const url = new URL(search.action, location.href);
    url.searchParams.set('q', field.value.trim());
    url.searchParams.set('type', 'product');
    location.assign(url.href);
  };
  search.querySelector('button[type="submit"]').addEventListener('click', event => { event.preventDefault(); go(); });
  field.addEventListener('keydown', event => {
    if (event.key === 'Enter' && !event.isComposing) { event.preventDefault(); go(); }
  });
})();
